import Reveal from "./Reveal";
import { SERVICES, waLink } from "@/config";
import { WaIcon } from "./Nav";

const spans = [
  "md:col-span-7",
  "md:col-span-5",
  "md:col-span-5",
  "md:col-span-7",
];

const Services = () => (
  <section id="servicios" className="relative py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <Reveal>
        <p className="font-mono text-xs tracking-[0.25em] text-aqua uppercase">— Servicios</p>
        <h2 className="mt-4 font-display font-bold uppercase leading-[1.02] text-[clamp(2rem,4.5vw,3.6rem)]">
          Elige tu <span className="text-outline">brillo</span>
        </h2>
        <p className="mt-4 max-w-xl text-white/60">
          Precios claros y resultados de escudería. Todos los servicios incluyen productos premium y
          acabado a mano.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-5">
        {SERVICES.map((s, i) => (
          <Reveal key={s.slug} delay={i * 0.08} className={`h-full ${spans[i]}`}>
            <article
              data-testid={`service-card-${s.slug}`}
              className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03] transition-all duration-500 hover:border-aqua/40 hover:shadow-[0_0_50px_rgba(0,242,254,0.08)]"
            >
              <div className="relative h-52 md:h-60 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.name}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink2 via-ink/20 to-transparent" />
                <span className="absolute top-4 right-4 rounded-full glass px-4 py-1.5 font-mono text-xs text-gold">
                  {s.price}
                </span>
              </div>

              <div className="flex flex-1 flex-col gap-3 p-6 md:p-7">
                <h3 className="font-display text-2xl font-bold">{s.name}</h3>
                <p className="text-sm md:text-base text-white/60 leading-relaxed">{s.desc}</p>
                <ul className="mt-1 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1.5">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 font-mono text-[11px] text-white/45">
                      <span className="inline-block h-1 w-1 rounded-full bg-aqua" />
                      {f}
                    </li>
                  ))}
                </ul>
                <div className="mt-auto pt-5">
                  <a
                    href={waLink(`Hola, quiero pedir cita para el servicio: ${s.name} (${s.price}).`)}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`service-book-${s.slug}`}
                    className="inline-flex items-center gap-2 rounded-full border border-aqua/40 px-5 py-2.5 text-sm text-aqua transition-all duration-300 hover:bg-aqua hover:text-ink"
                  >
                    <WaIcon size={14} />
                    Pedir este servicio
                  </a>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
